import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    showInstallationBanner: false,
    recordingsVisitor: [],
    refresher: 0,
    notifFeedback: 0,
    widget_id: 0,
    monthly_pageview: 0,
    currentUser: null,
    userInfo: null,
    stats: '',
    feedbackStatusState: 0,
    pattern: '',
    columnChart: {},
    devices: '',
    widgets: '',
    records: '',
    starredrecords: '',
    contacts: '',
    lineChart: '',
    totalRated: 0,
    faces: '1,2,3,4,5',
    tab: {
      feedback: 1,
      funnelFlow: 1,
      analytics: 1,
      events: 1,
      heatmap:1
    },
    datepicker: {
      record: {
        startDate: '',
        endDate: ''
      },
      heatmap: {
        startDate: '',
        endDate: ''
      },
      form: {
        startDate: '',
        endDate: ''
      },
      funnel: {
        startDate: '',
        endDate: ''
      },
      funneldetails: {
        startDate: '',
        endDate: ''
      },
      events: {
        startDate: '',
        endDate: ''
      },
      eventdetails: {
        startDate: '',
        endDate: ''
      },
      analytics: {
        startDate: '',
        endDate: ''
      },
      dashboard: {
        startDate: '',
        endDate: ''
      },
      feedback: {
        startDate: '',
        endDate: ''
      },
      poll: {
        startDate: '',
        endDate: ''
      }
    }
  },
  mutations: {
    setInstallationBanner (state, value) {
      state.showInstallationBanner = value
    },
    setFeedbackStatusState (state, value) {
      state.feedbackStatusState = value
    },
    setMonthlyPageview (state, value) {
      state.monthly_pageview = value
    },
    setWidgetId (state, value) {
      state.widget_id = value
    },
    setCurrentUser (state, payload) {
      state.currentUser = payload
    },
    setDatepicker(state, value) {
      state.datepicker[value.module][value.name] = value.data
    },
    setTab(state, value) {
      state.tab[value.module] = value.data
    },
    setUserInfo(state, value) {
      state.userInfo = value
    },
    setDevices(state, value) {
      state.devices = value
    },
    setWidgets(state, value) {
      state.widgets = value
    },
    setContacts(state, value) {
      state.contacts = value
    },
    setTotalRated(state, value) {
      state.totalRated = value
    },
    setPattern(state, value) {
      state.pattern = value
    },
    setStats(state, value) {
      state.stats = value
    },
    setLineChart(state, value) {
      state.lineChart = value
    },
    setColumnChart(state, value) {
      state.columnChart[value.name] = value.data
    },
    setFaces(state, value) {
      state.faces = value
    },
    setRecords(state, value) {
      state.records = value
    },
    setStarredRecords(state, value) {
      state.starredrecords = value
    },
    setRecordingsVisitor(state, value) {
      state.recordingsVisitor = value
    },
    setNotifFeedback(state, value) {
      state.notifFeedback = value
    },
    setRefresher(state, value) {
      state.refresher = value
    }    
  },
  getters: {
    showInstallationBanner: state => state.showInstallationBanner,
    feedbackStatusState: state => state.feedbackStatusState,
    faces: state => state.faces,
    records: state => state.records,
    recordingsVisitor: state => state.recordingsVisitor,
    starredrecords: state => state.starredrecords,
    datepicker: state => state.datepicker,
    tab: state => state.tab,
    userInfo: state => state.userInfo,
    totalRated: state => state.totalRated,
    devices: state => state.devices,
    widgets: state => state.widgets,
    contacts: state => state.contacts,
    stats: state => state.stats,
    pattern: state => state.pattern,
    refresher: state => state.refresher,
    lineChart: state => state.lineChart,
    columnChart: state => state.columnChart,
    monthly_pageview: state => state.monthly_pageview,
    widget_id: state => state.widget_id,
    notifFeedback: state => state.notifFeedback
  }
})



// WEBPACK FOOTER //
// ./src/store.js